module.exports = __webpack_public_path__ + "img/btn_OCR_hover.03ed41f5.png";